<template>
  <div
    class="button-dropdown"
    v-click-outside="{
      exclude: [],
      handler: 'clickOutside',
    }"
  >
    <button class="button button--danger button--icon-right" @click="setActive">
      <div>{{ $t('button-dropdown.reject') }}</div>

      <div class="button__icon">
        <i class="fas fa-caret-down"></i>
      </div>
    </button>

    <div
      class="button-dropdown__actions"
      :class="{ 'button-dropdown__actions--active': isActive }"
    >
      <button
        v-for="(option, i) in options"
        :key="i"
        class="button-dropdown__action"
        :class="option.buttonClass"
        @click="action(option.action)"
      >
        {{ $t(option.title) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isActive: false,
    };
  },

  methods: {
    action(name) {
      this.$emit('action', name);
      this.isActive = false;
    },

    setActive() {
      this.isActive = !this.isActive;
    },

    clickOutside() {
      this.isActive = false;
    },
  },
};
</script>
